/* eslint-disable @typescript-eslint/restrict-template-expressions */
// imports
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded'
import AirlineStopsRoundedIcon from '@mui/icons-material/AirlineStopsRounded'
import Battery4BarRoundedIcon from '@mui/icons-material/Battery4BarRounded'
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded'
import Brightness1RoundedIcon from '@mui/icons-material/Brightness1Rounded'
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded'
import CastConnectedIcon from '@mui/icons-material/CastConnected'
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded'
import ElectricCarIcon from '@mui/icons-material/ElectricCar'
import HexagonRoundedIcon from '@mui/icons-material/HexagonRounded'
import InfoIcon from '@mui/icons-material/Info'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import MedicalInformationRoundedIcon from '@mui/icons-material/MedicalInformationRounded'
import RectangleRoundedIcon from '@mui/icons-material/RectangleRounded'
import RouteIcon from '@mui/icons-material/Route'
import SecurityIcon from '@mui/icons-material/Security'
import SpeedIcon from '@mui/icons-material/Speed'
import '../../Style.css'
import TaxiAlertRoundedIcon from '@mui/icons-material/TaxiAlertRounded'
import {
  Avatar,
  Backdrop,
  Badge,
  BadgeProps,
  Box,
  Button,
  Card,
  CardActionArea,
  CardHeader,
  CircularProgress,
  Container,
  Grid,
  SpeedDialAction,
  Typography,
} from '@mui/material'
import SpeedDial, { SpeedDialProps } from '@mui/material/SpeedDial'
import SpeedDialIcon from '@mui/material/SpeedDialIcon'
import { styled, useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import { Dispatch } from '@reduxjs/toolkit'
import axios from 'axios'
import { circle } from 'leaflet'
import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import gregorian from 'react-date-object/calendars/gregorian'
import persian from 'react-date-object/calendars/persian'
import gregorian_en from 'react-date-object/locales/gregorian_en'
import persian_fa from 'react-date-object/locales/persian_fa'
import { useTranslation } from 'react-i18next'
import { DateObject } from 'react-multi-date-picker'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import Speedometer, {
  Background,
  Arc,
  Needle,
  Progress,
  Marks,
  Indicator,
  DangerPath,
} from 'react-speedometer'
import sf from 'seconds-formater'

import iranflag12 from '../../assests/icons/12.png'
import iranflag2 from '../../assests/icons/2.png'
import iranflag24 from '../../assests/icons/24.png'
import iranflag48 from '../../assests/icons/48.png'
import iranflag6 from '../../assests/icons/6.png'
import errorsIco from '../../assests/icons/errors.png'
import infoIco from '../../assests/icons/info.png'
import locationIco from '../../assests/icons/location.png'
import pathIco from '../../assests/icons/path.png'
import periodIco from '../../assests/icons/period.png'
import securityIco from '../../assests/icons/security.png'
import statusIco from '../../assests/icons/status.png'
import tripsIco from '../../assests/icons/trips.png'
import * as routes from '../../config/constants'
import { IsServiceItem } from '../../interfaces/IsServiceItem'
import { IsStatusBarItem } from '../../interfaces/IsStatusBarItem'
import NumberPlate from '../../shared/NumberPlate'
import ServiceItemContainer from '../../shared/ServiceItemContainer'
import StatusItemContainer from '../../shared/StatusItemContainer'
import {
  deviceList,
  GeofenceActivitiesList,
  GeofencesList,
  getDevice,
  getDeviceInfo,
  getDeviceStatus,
  getDistanceTraveled,
  getGeofenceActivitiesList,
  getGeofenceList,
  getLastObd,
  getLastPosition,
  getLastPositionDevice,
  getLastReObd,
  getLastTrouble,
  getLatiTude,
  getLoading,
  getLongiTude,
  getOdo,
  getOnlyDevice,
  getOnStatusDevice,
  getTraveledDistance,
  getTroubleLast,
  LastPositionDevice,
  resetDevice,
  resetDeviceSet,
  resetLastPosition,
  resetOnStatus,
  resetTraveledDistance,
  resetTroubleCode,
} from '../../store/devices'

// CarDetailsScreen Function
const CarDetailsScreen = () => {
  const { t } = useTranslation()
  const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    '& .MuiBadge-badge': {
      right: -3,
      backgroundColor: 'red',
      top: 13,
      border: `2px solid ${theme.palette.background.paper}`,
      padding: '0 4px',
    },
  }))
  const StyledBadge1 = styled(Badge)<BadgeProps>(({ theme }) => ({
    '& .MuiBadge-badge': {
      left: 0,
      backgroundColor: 'red',
      top: 13,
      border: `2px solid ${theme.palette.background.paper}`,
      padding: '0 4px',
    },
  }))

  const rows = useSelector(getDistanceTraveled)
  const loading = useSelector(getLoading)

  const dispatch = useDispatch<Dispatch<any>>()
  const StyledSpeedDial = styled(SpeedDial)(({ theme }) => ({
    position: 'absolute',
    '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
      bottom: theme.spacing(0),
      right: theme.spacing(0),
    },
    '&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight': {
      top: { xs: '20vh', sm: '30vh', md: '30vh', lg: '40vh' },
      left: theme.spacing(2),
    },
  }))
  // تابع تبدیل تاریخ به تاریخ امروز
  const shamsiToday = () => {
    const date = new DateObject({
      date: new Date(),
      format: 'YYYY/MM/DD HH:mm:ss',
    })
    date.convert(persian, persian_fa)

    return date.weekDay.name + '  ' + date.format('DD - MMMM - YYYY')
  }
  // تابع تبدیل تاریخ به تاریخ گذشته
  const actions: IsServiceItem[] = [
    {
      id: '1',
      title: 'دو ساعت قبل',
      icon: <img src={iranflag2} width='30px' />,
      onClick: () => {
        const date = new DateObject({
          date: new Date(),
          format: 'YYYY/MM/DD HH:mm:ss',
        })

        date.subtract(5, 'hour')
        date.subtract(30, 'minute')
        const startDate1 = date.format('YYYY-MM-DD HH:mm')
        date.add(2, 'hour')
        const endDate1 = date.format('YYYY-MM-DD HH:mm')

        // date.add(30, 'minute')

        dispatch(
          getTraveledDistance({
            deviceId: id,
            startDateTime: startDate1,
            endDateTime: endDate1,
          }),
        )
        setLabelTime(t('screens.CarDetailsScreen.2hoursAgo'))
      },
    },
    {
      id: '2',
      title: 'شش ساعت قبل',
      icon: <img src={iranflag6} width='30px' />,
      onClick: () => {
        const date = new DateObject({
          date: new Date(),
          format: 'YYYY/MM/DD HH:mm:ss',
        })

        date.subtract(9, 'hour')
        date.subtract(30, 'minute')

        const startDate1 = date.format('YYYY-MM-DD HH:mm')

        date.add(6, 'hour')
        // date.add(30, 'minute')

        const endDate1 = date.format('YYYY-MM-DD HH:mm')

        dispatch(
          getTraveledDistance({
            deviceId: id,
            startDateTime: startDate1,
            endDateTime: endDate1,
          }),
        )
        setLabelTime(t('screens.CarDetailsScreen.6hoursAgo'))
      },
    },

    {
      id: '3',
      title: 'دواده ساعت قبل',
      icon: <img src={iranflag12} width='30px' />,
      onClick: () => {
        const date = new DateObject({
          date: new Date(),
          format: 'YYYY/MM/DD HH:mm:ss',
        })

        date.subtract(15, 'hour')
        date.subtract(30, 'minute')

        const startDate1 = date.format('YYYY-MM-DD HH:mm')

        date.add(12, 'hour')
        // date.add(30, 'minute')

        const endDate1 = date.format('YYYY-MM-DD HH:mm')

        dispatch(
          getTraveledDistance({
            deviceId: id,
            startDateTime: startDate1,
            endDateTime: endDate1,
          }),
        )
        setLabelTime(t('screens.CarDetailsScreen.12hoursAgo'))
      },
    },
    {
      id: '4',
      title: 'بیست و چهار ساعت قبل',
      icon: <img src={iranflag24} width='30px' />,
      onClick: () => {
        const date = new DateObject({
          date: new Date(),
          format: 'YYYY/MM/DD HH:mm:ss',
        })
        date.subtract(1, 'day')
        date.subtract(3, 'hour')
        date.subtract(30, 'minute')

        const startDate1 = date.format('YYYY-MM-DD HH:mm')
        date.add(1, 'day')

        const endDate1 = date.format('YYYY-MM-DD HH:mm')

        dispatch(
          getTraveledDistance({
            deviceId: id,
            startDateTime: startDate1,
            endDateTime: endDate1,
          }),
        )
        setLabelTime(t('screens.CarDetailsScreen.24hoursAgo'))
      },
    },
    {
      id: '5',
      title: 'چهل و هشت ساعت قبل',
      icon: <img src={iranflag48} width='30px' />,
      onClick: () => {
        const date = new DateObject({
          date: new Date(),
          format: 'YYYY/MM/DD HH:mm:ss',
        })
        date.subtract(2, 'day')
        date.subtract(3, 'hour')
        date.subtract(30, 'minute')

        const startDate1 = date.format('YYYY-MM-DD HH:mm')
        date.add(2, 'day')

        const endDate1 = date.format('YYYY-MM-DD HH:mm')

        dispatch(
          getTraveledDistance({
            deviceId: id,
            startDateTime: startDate1,
            endDateTime: endDate1,
          }),
        )

        setLabelTime(t('screens.CarDetailsScreen.48hoursAgo'))
      },
    },
  ]
  const [labelTime, setLabelTime] = useState<any>(t('screens.CarDetailsScreen.no_info'))
  const [hidden, setHidden] = React.useState(false)
  const { id } = useParams()
  const deviceInfo = useSelector(getDeviceInfo)
  const OnlyDevice = useSelector(getOnlyDevice)
  const positionDevice = useSelector(getLastPositionDevice)

  const navigate = useNavigate()
  const location = useLocation()
  const listGeofence = useSelector(getGeofenceList)

  const activitiesGeoList = useSelector(getGeofenceActivitiesList)

  const lastTrouble = useSelector(getTroubleLast)

  const latitude = useSelector(getLatiTude)
  const longitude = useSelector(getLongiTude)
  const onStatus = useSelector(getOnStatusDevice)
  // گرفتن موقعیت و لیست دیوایس ها در ایتدای ورود به صفحه
  useEffect(() => {
    dispatch(LastPositionDevice(location.state.id))
    dispatch(getLastPosition(location.state.id))
    dispatch(getDevice(location.state.id))
    dispatch(GeofenceActivitiesList({ deviceId: id }))
    dispatch(GeofencesList({ deviceId: id }))
    dispatch(resetTroubleCode)

    dispatch(getLastTrouble({ deviceId: id }))
  }, [])
  // نمایش دکمه ها موقعیت ، خطاها و غیره

  const Services: IsServiceItem[] = [
    {
      id: '1',
      title: t('screens.CarDetailsScreen.geofencing_location'),
      icon: (
        <StyledBadge1
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          badgeContent={listGeofence.length !== 0 ? activitiesGeoList?.count : 0}
          color='secondary'
        >
          <img src={locationIco} style={{ marginTop: 4 }} width='30px' />
        </StyledBadge1>
      ),
      onClick: () => {
        if (latitude === '' || longitude === '') return
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        navigate(`/${routes.LOCATION}/${id}`)
      },
    },

    {
      id: '3',
      title: t('screens.CarDetailsScreen.pathes'),
      icon: <img src={pathIco} style={{ marginTop: 4 }} width='30px' />,
      onClick: () => {
        // dispatch(getOdo(location.state.id))
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        navigate(`/${routes.PATHS_TRAVELED}/${id}`, { state: { location } })
      },
    },
    {
      id: '4',
      title: t('screens.CarDetailsScreen.info_engine'),
      icon: <img src={infoIco} style={{ marginTop: 4 }} width='30px' />,
      onClick: () => {
        dispatch(getLastReObd(location.state.id))
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        navigate(`/${routes.INFO_ENGINE}/${id}`, { state: { location } })
      },
    },
    {
      id: '5',
      title: t('screens.CarDetailsScreen.errors'),
      icon: (
        <StyledBadge badgeContent={lastTrouble?.length} color='secondary'>
          <img src={errorsIco} style={{ marginTop: 4 }} width='40px' />
        </StyledBadge>
      ),
      onClick: () => {
        dispatch(getLastTrouble({ deviceId: location.state.id }))
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        navigate(`/${routes.ERROR_ENGINE}/${id}`, { state: { location } })
      },
    },
    {
      id: '6',
      title: t('screens.CarDetailsScreen.periodic_service'),
      icon: <img src={periodIco} style={{ marginTop: 4 }} width='30px' />,
      onClick: () => {
        navigate(`/${routes.PERIODIC_SERVICE}/${id}`)
      },
    },
    {
      id: '9',
      title: t('screens.CarDetailsScreen.trips'),
      icon: <img src={tripsIco} style={{ marginTop: 4 }} width='60px' />,
      onClick: () => {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        navigate(`/${routes.TRIPS_CAR}/${id}`)
      },
    },
    {
      id: '7',
      title: t('screens.CarDetailsScreen.security'),
      icon: <img src={securityIco} style={{ marginTop: 4 }} width='30px' />,
      onClick: () => {
        navigate(`/${routes.SECURITY}/${id}`)
      },
    },
    {
      id: '8',
      title: t('screens.CarDetailsScreen.status_device'),
      icon: <img src={statusIco} style={{ marginTop: 4 }} width='30px' />,
      onClick: () => {
        dispatch(getDeviceStatus(location.state.id))
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        navigate(`/${routes.STATUS_DEVICE}/${id}`)
      },
    },
  ]
  // عکس های شرکت سازنده خودروها براساس مقادیر اولیه
  useEffect(() => {
    window.scrollTo(0, 1000)
  }, [])
  const getCarCompany77 = (companyId: string) => {
    switch (companyId) {
      case '1':
        return '/images/saipa.png'
      case '2':
        return '/images/iran-Khodro.png'
      case '3':
        return '/images/bahman.png'
      case '4':
        return '/images/mvm.png'
      case '5':
        return '/images/chery.png'
      case '6':
        return '/images/dongFang.png'
      case '7':
        return '/images/bmw.png'
      case '8':
        return '/images/jili.png'
      case '9':
        return '/images/faw.png'
      case '10':
        return '/images/gratewall.png'
      case '11':
        return '/images/kerman.png'
      case '12':
        return '/images/foton.png'
      case '13':
        return '/images/reno.png'
      case '14':
        return '/images/pegout.png'
      case '15':
        return '/images/asna.png'
      case '16':
        return '/images/jac.png'
      case '17':
        return '/images/mazda.png'
      case '18':
        return '/images/lifan.png'
      case '19':
        return '/images/songyong.png'
      case '20':
        return '/images/toyota.png'
      case '21':
        return '/images/zamyad.png'
      case '22':
        return '/images/huangHia.png'
      case '23':
        return '/images/kia.png'
      case '24':
        return '/images/poroton.png'
      case '25':
        return '/images/hyonda.png'
      case '26':
        return '/images/citroen.png'
      case '27':
        return '/images/benz.png'
      case '28':
        return '/images/mg.png'
      case '29':
        return '/images/haima.png'
      case '30':
        return '/images/suzuki.png'
      case '31':
        return '/images/pars.png'
      case '32':
        return '/images/changan.png'
      case '33':
        return '/images/devo.png'
      case '34':
        return '/images/bayk.png'
      case '35':
        return '/images/phonix.png'
      case '36':
        return '/images/farda.png'
      case '37':
        return '/images/lamari.png'
      case '38':
        return '/images/rigan.png'
      case '39':
        return '/images/biso.png'
      case '40':
        return '/images/byd.png'
      case '41':
        return '/images/damay.png'
      case '42':
        return '/images/bogoard.png'
      case '43':
        return '/images/henteng.png'
      case '44':
        return '/images/uaz.png'
      case '45':
        return '/images/hawal.png'
      case '46':
        return '/images/swm.png'
      case '47':
        return '/images/folex.png'
      case '48':
        return '/images/nisan.png'
      case '49':
        return '/images/mitsu.png'

      default:
        return '/images/bayk.png'
    }
  }
  const getCarCompany = (companyId: any) => {
    if (companyId < 47) {
      return '/images/saipa.png'
    } else if (companyId === 47 || companyId < 100) {
      return '/images/iran-Khodro.png'
    } else if (companyId === 100 || companyId < 128) {
      return '/images/bahman.png'
    } else if (companyId === 128 || companyId < 146) {
      return '/images/mvm.png'
    } else if (companyId === 146 || companyId < 158) {
      return '/images/chery.png'
    } else if (companyId === 158 || companyId < 166) {
      return '/images/dongFang.png'
    } else if (companyId === 166 || companyId < 249) {
      return '/images/bmw.png'
    } else if (companyId === 249 || companyId < 265) {
      return '/images/jili.png'
    } else if (companyId === 265 || companyId < 274) {
      return '/images/faw.png'
    } else if (companyId === 274 || companyId < 289) {
      return '/images/gratewall.png'
    } else if (companyId === 289 || companyId < 317) {
      return '/images/kerman.png'
    } else if (companyId === 317 || companyId < 329) {
      return '/images/foton.png'
    } else if (companyId === 329 || companyId < 358) {
      return '/images/reno.png'
    } else if (companyId === 358 || companyId < 370) {
      return '/images/pegout.png'
    } else if (companyId === 370 || companyId < 377) {
      return '/images/asna.png'
    } else if (companyId === 377 || companyId < 393) {
      return '/images/jac.png'
    } else if (companyId === 393 || companyId < 405) {
      return '/images/mazda.png'
    } else if (companyId === 405 || companyId < 419) {
      return '/images/lifan.png'
    } else if (companyId === 419 || companyId < 440) {
      return '/images/songyong.png'
    } else if (companyId === 440 || companyId < 496) {
      return '/images/toyota.png'
    } else if (companyId === 496 || companyId < 507) {
      return '/images/zamyad.png'
    } else if (companyId === 507 || companyId < 512) {
      return '/images/huangHia.png'
    } else if (companyId === 512 || companyId < 536) {
      return '/images/kia.png'
    } else if (companyId === 536 || companyId < 547) {
      return '/images/poroton.png'
    } else if (companyId === 547 || companyId < 578) {
      return '/images/hyonda.png'
    } else if (companyId === 578 || companyId < 585) {
      return '/images/citroen.png'
    } else if (companyId === 585 || companyId < 669) {
      return '/images/benz.png'
    } else if (companyId === 669 || companyId < 686) {
      return '/images/mg.png'
    } else if (companyId === 686 || companyId < 696) {
      return '/images/haima.png'
    } else if (companyId === 696 || companyId < 706) {
      return '/images/suzuki.png'
    } else if (companyId === 706 || companyId < 729) {
      return '/images/pars.png'
    } else if (companyId === 729 || companyId < 737) {
      return '/images/changan.png'
    } else if (companyId === 737 || companyId < 743) {
      return '/images/devo.png'
    } else if (companyId === 743 || companyId < 748) {
      return '/images/bayk.png'
    } else if (companyId === 748 || companyId < 759) {
      return '/images/phonix.png'
    } else if (companyId === 759 || companyId < 769) {
      return '/images/farda.png'
    } else if (companyId === 769 || companyId < 774) {
      return '/images/lamari.png'
    } else if (companyId === 774 || companyId < 779) {
      return '/images/rigan.png'
    } else if (companyId === 779 || companyId < 783) {
      return '/images/biso.png'
    } else if (companyId === 783 || companyId < 789) {
      return '/images/byd.png'
    } else if (companyId === 789 || companyId < 792) {
      return '/images/damay.png'
    } else if (companyId === 792 || companyId < 796) {
      return '/images/bogoard.png'
    } else if (companyId === 796 || companyId < 800) {
      return '/images/henteng.png'
    } else if (companyId === 800 || companyId < 804) {
      return '/images/uaz.png'
    } else if (companyId === 804 || companyId < 813) {
      return '/images/hawal.png'
    } else if (companyId === 813 || companyId < 817) {
      return '/images/swm.png'
    } else if (companyId === 817 || companyId < 827) {
      return '/images/folex.png'
    } else if (companyId === 827 || companyId < 841) {
      return '/images/nisan.png'
    } else if (companyId === 841 || companyId < 890) {
      return '/images/mitsu.png'
    }
  }
  // لیست شرکت سازنده خودروها
  const getCarCompany1 = (companyId: any) => {
    if (companyId < 47) {
      return 'سایپا'
    } else if (companyId === 47 || companyId < 100) {
      return 'ایرانخودرو'
    } else if (companyId === 100 || companyId < 128) {
      return 'بهمن'
    } else if (companyId === 128 || companyId < 146) {
      return 'ام وی ام'
    } else if (companyId === 146 || companyId < 158) {
      return 'چری'
    } else if (companyId === 158 || companyId < 166) {
      return 'دانگ فنگ'
    } else if (companyId === 166 || companyId < 249) {
      return 'بی ام و'
    } else if (companyId === 249 || companyId < 265) {
      return 'جیلی'
    } else if (companyId === 265 || companyId < 274) {
      return 'فاو'
    } else if (companyId === 274 || companyId < 289) {
      return 'گریت وال'
    } else if (companyId === 289 || companyId < 317) {
      return 'کرمان موتور'
    } else if (companyId === 317 || companyId < 329) {
      return 'فوتون'
    } else if (companyId === 329 || companyId < 358) {
      return 'رنو'
    } else if (companyId === 358 || companyId < 370) {
      return 'پژو'
    } else if (companyId === 370 || companyId < 377) {
      return 'آسنا'
    } else if (companyId === 377 || companyId < 393) {
      return 'جک'
    } else if (companyId === 393 || companyId < 405) {
      return 'مزدا'
    } else if (companyId === 405 || companyId < 419) {
      return 'لیفان'
    } else if (companyId === 419 || companyId < 440) {
      return 'سانگ یانگ'
    } else if (companyId === 440 || companyId < 496) {
      return 'تویوتا'
    } else if (companyId === 496 || companyId < 507) {
      return 'زامیاد'
    } else if (companyId === 507 || companyId < 512) {
      return 'Huang Hia'
    } else if (companyId === 512 || companyId < 536) {
      return 'کیا'
    } else if (companyId === 536 || companyId < 547) {
      return 'پروتون'
    } else if (companyId === 547 || companyId < 578) {
      return 'هیوندا'
    } else if (companyId === 578 || companyId < 585) {
      return 'سیتروئن'
    } else if (companyId === 585 || companyId < 669) {
      return 'مرسدس بنز'
    } else if (companyId === 669 || companyId < 686) {
      return 'ام جی'
    } else if (companyId === 686 || companyId < 696) {
      return 'هایما'
    } else if (companyId === 696 || companyId < 706) {
      return 'سوزوکی'
    } else if (companyId === 706 || companyId < 729) {
      return 'پارس خودرو'
    } else if (companyId === 729 || companyId < 737) {
      return 'چانگان'
    } else if (companyId === 737 || companyId < 743) {
      return 'دوو'
    } else if (companyId === 743 || companyId < 748) {
      return 'بایک'
    } else if (companyId === 748 || companyId < 759) {
      return 'فونیکس'
    } else if (companyId === 759 || companyId < 769) {
      return 'فردا'
    } else if (companyId === 769 || companyId < 774) {
      return 'لاماری'
    } else if (companyId === 774 || companyId < 779) {
      return 'ریگان'
    } else if (companyId === 779 || companyId < 783) {
      return 'بیسو'
    } else if (companyId === 783 || companyId < 789) {
      return 'بی وای دی'
    } else if (companyId === 789 || companyId < 792) {
      return 'دامای'
    } else if (companyId === 792 || companyId < 796) {
      return 'بورگوارد'
    } else if (companyId === 796 || companyId < 800) {
      return 'هن تنگ'
    } else if (companyId === 800 || companyId < 804) {
      return 'یوآز'
    } else if (companyId === 804 || companyId < 813) {
      return 'هاوال'
    } else if (companyId === 813 || companyId < 817) {
      return 'اس دبلیو ام'
    } else if (companyId === 817 || companyId < 827) {
      return 'فولکس'
    } else if (companyId === 827 || companyId < 841) {
      return 'نیسان'
    } else if (companyId === 841 || companyId < 890) {
      return 'میتسوبیشی'
    }
  }
  const getCarCompanyTitle = (companyId: string) => {
    switch (companyId) {
      case '1':
        return 'سایپا'
      case '2':
        return 'ایرانخودرو'
      case '3':
        return 'بهمن'
      case '4':
        return 'ام وی ام'
      case '5':
        return 'چری'
      case '6':
        return 'دانگ فنگ'
      case '7':
        return 'بی ام و'
      case '8':
        return 'جیلی'
      case '9':
        return 'فاو'
      case '10':
        return 'گریت وال'
      case '11':
        return 'کرمان موتور'
      case '12':
        return 'فوتون'
      case '13':
        return 'رنو'
      case '14':
        return 'پژو'
      case '15':
        return 'آسنا'
      case '16':
        return 'جک'
      case '17':
        return 'مزدا'
      case '18':
        return 'لیفان'
      case '19':
        return 'سانگ یانگ'
      case '20':
        return 'تویوتا'
      case '21':
        return 'زامیاد'
      case '22':
        return 'Huang Hia '
      case '23':
        return 'کیا'
      case '24':
        return 'پروتون'
      case '25':
        return 'هیوندا'
      case '26':
        return 'سیتروئن'
      case '27':
        return 'مرسدس بنز'
      case '28':
        return 'ام جی'
      case '29':
        return 'هایما'
      case '30':
        return 'سوزوکی'
      case '31':
        return 'پارس خودرو'
      case '32':
        return 'چانگان'
      case '33':
        return 'دوو'
      case '34':
        return 'بایک'
      case '35':
        return 'فونیکس'
      case '36':
        return 'فردا'
      case '37':
        return 'لاماری'
      case '38':
        return 'ریگان'
      case '39':
        return 'بیسو'
      case '40':
        return 'بی وای دی'
      case '41':
        return 'دامای'
      case '42':
        return 'بورگوارد'
      case '43':
        return 'هن تنگ'
      case '44':
        return 'یوآز'
      case '45':
        return 'هاوال'
      case '46':
        return 'اس دبلیو ام'
      case '47':
        return 'فولکس'
      case '48':
        return 'نیسان'
      case '49':
        return 'میتسوبیشی'

      default:
        return ''
    }
  }
  // اطلاعات مربوط به ریسپانسیو صفحه

  const matches = useMediaQuery('(min-width:600px)')
  const matches1 = useMediaQuery('(max-width:300px)')

  const theme = useTheme()
  const onlySmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const onlyMediumScreen = useMediaQuery(theme.breakpoints.down('md'))
  const onlyLargeScreen = useMediaQuery(theme.breakpoints.down('lg'))
  const onxlyLargeScreen = useMediaQuery(theme.breakpoints.down('xl'))

  const responsiveValue = matches1
    ? 110
    : onlySmallScreen
    ? 150
    : onlyMediumScreen
    ? 300
    : onlyLargeScreen
    ? 350
    : onxlyLargeScreen
    ? 250
    : 250
  const responsiveFontSize = matches1
    ? 10
    : onlySmallScreen
    ? 10
    : onlyMediumScreen
    ? 20
    : onlyLargeScreen
    ? 20
    : onxlyLargeScreen
    ? 15
    : 15
  const responsiveLineSize = matches1
    ? 5
    : onlySmallScreen
    ? 12
    : onlyMediumScreen
    ? 20
    : onlyLargeScreen
    ? 20
    : onxlyLargeScreen
    ? 20
    : 20
  const responsiveFontSizeText = matches1
    ? 10
    : onlySmallScreen
    ? 8
    : onlyMediumScreen
    ? 15
    : onlyLargeScreen
    ? 20
    : onxlyLargeScreen
    ? 15
    : 15
  const responsiveStroke = matches1
    ? 1
    : onlySmallScreen
    ? 2
    : onlyMediumScreen
    ? 5
    : onlyLargeScreen
    ? 8
    : onxlyLargeScreen
    ? 8
    : 5
  const responsiveCircle = matches1
    ? 5
    : onlySmallScreen
    ? 10
    : onlyMediumScreen
    ? 20
    : onlyLargeScreen
    ? 20
    : onxlyLargeScreen
    ? 20
    : 20
  const responsiveText = matches1
    ? 5
    : onlySmallScreen
    ? 70
    : onlyMediumScreen
    ? 150
    : onlyLargeScreen
    ? 180
    : onxlyLargeScreen
    ? 125
    : 125
  const responsiveText1 = matches1
    ? 5
    : onlySmallScreen
    ? 200 / 2
    : onlyMediumScreen
    ? 380 / 2
    : onlyLargeScreen
    ? 440 / 2
    : onxlyLargeScreen
    ? 350 / 2
    : 350 / 2
  const responsiveText2 = matches1
    ? 5
    : onlySmallScreen
    ? 225 / 2
    : onlyMediumScreen
    ? 430 / 2
    : onlyLargeScreen
    ? 500 / 2
    : onxlyLargeScreen
    ? 405 / 2
    : 405 / 2
  const responsiveText3 = matches1
    ? 5
    : onlySmallScreen
    ? 255 / 2
    : onlyMediumScreen
    ? 470 / 2
    : onlyLargeScreen
    ? 560 / 2
    : onxlyLargeScreen
    ? 450 / 2
    : 450 / 2

  const responsiveBox = {
    '&.MuiBox-root': {
      // width: { xs: 100, sm: 100, md: 200, lg: 226 },
      paddingTop: { xs: 2, sm: 2, md: 2, lg: 0 },
    },
  }
  // تابع تبدیل تاریخ شمسی به میلادی

  const shamsi = (time: string) => {
    if (time === undefined) return
    const time1 = time
    const replaceTime = _.replace(time1, 'T', ' ')

    const date = new DateObject({
      date: replaceTime,
      format: 'YYYY/MM/DD HH:mm:ss',
    })
    date.convert(persian, persian_fa)
    date.add(3, 'hour')
    date.add(30, 'minute')
    return date.format('YYYY/MM/DD HH:mm:ss')
  }

  useEffect(() => {
    return () => {
      dispatch(resetTraveledDistance)
      dispatch(resetOnStatus)
      dispatch(resetLastPosition)
    }
  }, [])
  // تابع تبدیل متر به کیلومتر براساس ورودی متر

  const convertKilometer = (meter: number) => {
    if (meter < 1000) {
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      return _.split(meter.toString(), '.', 1) + 'M'
    } else {
      const convert = Math.round(meter / 100) / 10
      const convertation: any = _.split(convert.toString(), '.', 2)
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      const num1 = convertation[1] !== undefined ? convertation[1] * 100 + 'M' : ''

      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      return convertation[0] + 'Km:' + num1
    }
  }
  const [addressLive, setAddressLive] = useState<any>()
  const [iconLive, setIconLive] = useState<any>(undefined)

  return (
    <Box
      sx={{
        direction: 'ltr',
        overflow: { xs: 'hidden', sm: 'hidden', md: 'auto', lg: 'hidden' },
      }}
    >
      <Grid item justifyContent='center' lg={12} sm={12} xs={12}>
        {/* <StatusItemContainer items={items} /> */}
        <Box display='flex' flexDirection='column' height='90vh' justifyContent='space-between'>
          <Box>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Card
                dir='ltr'
                sx={{
                  margin: 1,
                  width: { xs: 1, sm: 2 / 4, md: 2 / 4, lg: 1.5 / 4 },
                  // backgroundImage: `url(${'/images/background1.jpg'})`,
                  background: 'linear-gradient(rgb(35 75 75), #aaaaaa)',
                  // backgroundRepeat: 'no-repeat',
                  backgroundSize: '350px 150px',
                  overflowY: 'hidden',
                  Height: '300vh',
                  '& .MuiCardHeader-root': { paddingRight: 0 },
                }}
              >
                <CardActionArea
                  onClick={() => {
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    navigate(`/${routes.NEW_CAR}/${id}`, { state: { location: location.state.id } })
                  }}
                  sx={{ width: '100%' }}
                >
                  <CardHeader
                    avatar={<Avatar src={getCarCompany(deviceInfo.model)} />}
                    subheader={deviceInfo.modelName}
                    sx={{
                      color: 'white',
                      direction: 'rtl',
                      '& .MuiCardHeader-avatar': { marginRight: 1 },
                      '& .MuiTypography-root': { marginRight: 1, fontSize: 18, color: 'white' },
                    }}
                    title={getCarCompany1(deviceInfo.model)}
                  />
                  {/* </Box> */}

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      p: 1,
                      width: '100%',
                      alignItems: 'center',
                    }}
                  >
                    <NumberPlate
                      first={deviceInfo?.numberPlate?.split('-')[0]}
                      forth={deviceInfo?.numberPlate?.split('-')[3]}
                      second={deviceInfo?.numberPlate?.split('-')[1]}
                      third={deviceInfo?.numberPlate?.split('-')[2]}
                    />
                    <Typography sx={{ color: '#fff', fontSize: '0.90rem' }}>
                      امروز:{shamsiToday()}
                    </Typography>
                  </Box>
                </CardActionArea>
              </Card>
            </Box>
            <ServiceItemContainer items={Services} />
          </Box>
          <Box sx={{ p: 2 }} width={1}>
            <Box
              alignItems='center'
              display='flex'
              flexDirection='column'
              sx={{
                backgroundColor: '#3d3d3d',
                pt: { xs: 2, sm: 2, md: 3, lg: 3 },
                borderRadius: '46% 51% 0% 0% / 13% 13% 25% 25%',
                width: '100%',
                boxShadow: '-7px -10px 10px #6f6f6f',
                height: '63vh',
              }}
            >
              <StyledSpeedDial
                ariaLabel='SpeedDial playground example'
                direction='right'
                hidden={hidden}
                icon={<AccessTimeRoundedIcon />}
                sx={{ '& .MuiSpeedDial-fab': { width: '40px', height: '40px' } }}
              >
                {actions.map((action) => (
                  <SpeedDialAction
                    icon={action.icon}
                    key={action.id}
                    onClick={action.onClick}
                    sx={{ background: 'red' }}
                    tooltipTitle={action.title}
                  />
                ))}
              </StyledSpeedDial>
              <Card
                sx={{
                  color: 'green',
                  backgroundColor: 'black',
                  borderRadius: 1,
                  width: { xs: 2 / 4, sm: 1 / 4, md: 1 / 4, lg: 1 / 4 },
                  display: 'flex',

                  mb: 1,
                  justifyContent: 'space-around',
                }}
              >
                {/* <Box display='flex'>
            <Typography sx={{ fontSize: 12 }}>
              {shamsi(rows?.otherData?.startDateTime)}
            </Typography>
          </Box> */}
                <Box display='flex'>
                  <Typography sx={{ fontSize: 12 }}>{labelTime}</Typography>
                </Box>
                {/* <Box display='flex'>
            <Typography sx={{ fontSize: 12 }}>{shamsi(rows?.otherData?.endDateTime)}</Typography>
          </Box> */}
              </Card>
              <Box display='flex' justifyContent='center' sx={responsiveBox}>
                <Box>
                  <Speedometer
                    fontFamily='squada-one'
                    max={24}
                    value={
                      rows?.otherData !== undefined && rows?.otherData !== null
                        ? rows?.otherData?.onTimeSeconds / 60 / 10
                        : 0
                    }
                    width={responsiveValue}
                  >
                    {/* <Background /> */}
                    <Arc arcWidth={0} />

                    <Needle
                      circleColor='white'
                      circleRadius={responsiveCircle}
                      color='red'
                      offset={40}
                    />

                    <Progress arcWidth={0} color='orange' />
                    <Marks
                      lineSize={responsiveLineSize}
                      numbersRadius={matches ? 15 : 10}
                      step={0.5}
                    >
                      {(mark, i) => (
                        <g key={i}>
                          {i % 4 === 0 && (
                            <text
                              {...mark.textProps}
                              alignmentBaseline='middle'
                              fill={
                                OnlyDevice?.deviceStatus?.isOn === true ? 'greenyellow' : 'white'
                              }
                              fontSize={responsiveFontSize}
                              opacity={0.6}
                              textAnchor='middle'
                            >
                              {mark.value}
                            </text>
                          )}
                          <line
                            {...mark.coordinates}
                            stroke={
                              OnlyDevice?.deviceStatus?.isOn === true ? 'greenyellow' : 'white'
                            }
                            strokeOpacity={1}
                            strokeWidth={responsiveStroke}
                          />
                        </g>
                      )}
                    </Marks>
                    <defs>
                      <filter height='1' id='solid' width='1' x='0' y='0'>
                        <feFlood floodColor='white' result='bg' />
                        <feMerge>
                          <feMergeNode in='bg' />
                          <feMergeNode in='SourceGraphic' />
                        </feMerge>
                      </filter>
                    </defs>
                    <Indicator>
                      {(value, textProps) => (
                        <text
                          {...textProps}
                          fill={OnlyDevice?.deviceStatus?.isOn === true ? 'greenyellow' : 'white'}
                          fontFamily='Vazir'
                          fontSize={responsiveFontSizeText}
                          style={{ border: '2px solod black' }}
                          textAnchor='middle'
                          x={responsiveText}
                          y={responsiveText1}
                        >
                          <>Time/ON</>
                          {/* <>{value}کیلومتر</> */}
                        </text>
                      )}
                    </Indicator>
                    <Indicator>
                      {(value, textProps) => (
                        <text
                          {...textProps}
                          clipPath=' polygon(30% 0%, 70% 0%, 100% 0, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0 0)'
                          fill='black'
                          filter='url(#solid)'
                          fontFamily='Vazir'
                          fontSize={responsiveFontSizeText}
                          textAnchor='middle'
                          x={responsiveText}
                          y={responsiveText2}
                        >
                          <>
                            {rows?.otherData !== undefined && rows?.otherData !== null
                              ? sf.convert(rows?.otherData?.onTimeSeconds).format('HH:MM:SS')
                              : 'NO INFO'}
                          </>
                        </text>
                      )}
                    </Indicator>
                    <Indicator>
                      {(value, textProps) => (
                        <text
                          {...textProps}
                          fill={OnlyDevice?.deviceStatus?.isOn === true ? 'greenyellow' : 'white'}
                          fontFamily='Vazir'
                          fontSize={responsiveFontSizeText}
                          textAnchor='middle'
                          x={responsiveText}
                          y={responsiveText3}
                        >
                          <>{t('screens.CarDetailsScreen.engine_running')}</>
                        </text>
                      )}
                    </Indicator>
                  </Speedometer>
                </Box>
                <Box sx={{ ml: 1 }}>
                  <Speedometer
                    fontFamily='squada-one'
                    max={220}
                    value={
                      rows?.otherData !== undefined && rows?.otherData !== null
                        ? rows?.otherData?.totalDistance / 1000
                        : 0
                    }
                    width={responsiveValue}
                  >
                    {/* <Background /> */}
                    <Arc arcWidth={0} />
                    <Needle
                      circleColor='white'
                      circleRadius={responsiveCircle}
                      color='red'
                      offset={35}
                    />
                    <Progress arcWidth={0} color={'red'} />
                    <Marks lineSize={responsiveLineSize} numbersRadius={matches ? 17 : 12}>
                      {(mark, i) => (
                        <g key={i}>
                          {i % 2 === 0 && (
                            <text
                              {...mark.textProps}
                              alignmentBaseline='central'
                              fill={
                                OnlyDevice?.deviceStatus?.isOn === true ? 'greenyellow' : 'white'
                              }
                              fontSize={responsiveFontSize}
                              opacity={0.6}
                              textAnchor='middle'
                            >
                              {mark.value}
                            </text>
                          )}

                          <line
                            {...mark.coordinates}
                            stroke={
                              OnlyDevice?.deviceStatus?.isOn === true ? 'greenyellow' : 'white'
                            }
                            strokeOpacity={1}
                            strokeWidth={responsiveStroke}
                          />
                        </g>
                      )}
                    </Marks>

                    <Indicator>
                      {(value, textProps) => (
                        <text
                          {...textProps}
                          clipPath=' polygon(30% 0%, 70% 0%, 100% 0, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0 0)'
                          fill='black'
                          filter='url(#solid)'
                          fontFamily='Vazir'
                          fontSize={responsiveFontSizeText}
                          textAnchor='middle'
                          x={responsiveText}
                          y={responsiveText2}
                        >
                          <>
                            {rows?.otherData !== undefined && rows?.otherData !== null
                              ? convertKilometer(rows?.otherData?.totalDistance)
                              : 'NO INFO'}
                          </>
                        </text>
                      )}
                    </Indicator>
                    <Indicator>
                      {(value, textProps) => (
                        <text
                          {...textProps}
                          fill={OnlyDevice?.deviceStatus?.isOn === true ? 'greenyellow' : 'white'}
                          fontFamily='Vazir'
                          fontSize={responsiveFontSizeText}
                          style={{ border: '2px solod black' }}
                          textAnchor='middle'
                          x={responsiveText}
                          y={responsiveText1}
                        >
                          <>KM:M</>
                          {/* <>{value}کیلومتر</> */}
                        </text>
                      )}
                    </Indicator>
                    <Indicator>
                      {(value, textProps) => (
                        <text
                          {...textProps}
                          fill={OnlyDevice?.deviceStatus?.isOn === true ? 'greenyellow' : 'white'}
                          fontFamily='Vazir'
                          fontSize={responsiveFontSizeText}
                          textAnchor='middle'
                          x={responsiveText}
                          y={responsiveText3}
                        >
                          <>{t('screens.CarDetailsScreen.covered_distance')}</>
                        </text>
                      )}
                    </Indicator>
                  </Speedometer>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Grid>
      <Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <div className='spinner'></div>
      </Backdrop>
    </Box>
  )
}

export default CarDetailsScreen
